import Vue from 'vue'
import VueRouter from 'vue-router'


import Home from '../views/Home.vue'
// import Contact from '../views/Contact.vue';
// import Register from '@/components/auth/Register'
import Login from '@/components/auth/Login'

// import Dashboard from '@/views/u/Dashboard'


// import fbServices from "@/firebase/init.js";
// const auth = fbServices.auth;

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: Register
  // },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    // meta: {
    //   requiresAuth: false // can only access if not logged in
    // }
  },

  // {
  //   path: '/dashboard',
  //   name: 'Dashboard',
  //   component: Dashboard,
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  

  
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import( '../views/About.vue') /* webpackChunkName: "about" */
  // },
  // {
  //   path: '/contact',
  //   name: 'contact',
  //   component: Contact // () => import('../views/Contact.vue')
  // },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach((to,from,next) => {
//   if(to.matched.some(record => record.meta.requiresAuth)) {
//     if(auth.loggedIn()) {
      
//       console.log('To',to);
//       // user logged in, proceed to login page
//       next()
      
//     } else {
//       // user not logged in, redirect to login page
//       next({path:'/login'});
//     }
//   } else {

//     console.log('TO not IN route with meta',to);
//     // user is logged in and goint to /login, redirect to dashboard
//     if(auth.loggedIn() && to.path === '/login') {
//       next({path:'/dashboard'})
//     } 
//     else {
//       next();
//     }
    
//   }
// })

export default router

